<template>
  <div :class="{ open: open }">
    <div class="sport-hat">
      <active-button
        class="sport-button"
        line-color="blue"
        line-position="left"
        :active="false /* !isActive('view', 'main') && $route.params.sport == sport.id */"
        @click="/* $router.push(`/prematch/sport/${sport.id}`) */"
      >
        <sport-icon-liga-white class="sport-icon-liga-white" :name="sport.alias" />
        <div class="sport-name ellipsis">{{ $i18n.locale ? sport['name_' + $i18n.locale] : sport.name }}</div>
      </active-button>
      <!--icon-button @click="open = !open">
        <arrow-icon :direction="open ? 'up' : 'down'"></arrow-icon>
      </icon-button-->
    </div>
    <div class="list">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import ActiveButton from '@/components/buttons/ActiveButton'
import IconButton from '@/components/buttons/IconButton'
import ArrowIcon from '@/components/icons/ArrowIcon'
import SportIconLigaWhite from '@/components/icons/SportIconLigaWhite'

export default {
  components: {
    ActiveButton,
    IconButton,
    ArrowIcon,
    SportIconLigaWhite
  },
  props: {
    sport: Object
  },
  data () {
    return {
      open: true
    }
  }
}
</script>

<style scoped>
.sport-icon-liga-white { margin: 9px -7px 10px 8px; }
.sport-hat { display: flex; }
.sport-button { display: flex; height: 40px; line-height: 40px; width: calc(100% - 10px); cursor: default; }
.sport-button:hover { background: none; }
.sport-button .sport-name { flex: 1; padding: 0 10px; font-size: 18px; }
.list { display: none; position: relative; }
.list:before { background: rgba(255, 255, 255, .1); bottom: 0; content: ''; float: left; height: 3px; left: 0; right: 0; position: absolute; transform: scaleX(0); transition: transform .3s; transform: scaleX(1); }
.open .list { display: block; }
</style>



// WEBPACK FOOTER //
// src/components/sports/main_sport_2/Sport.vue